module.exports = __webpack_public_path__ + "static/img/gold.e0f133ce.png";